import { BRAND_DTO_ENUMS } from "api/repositories/brand/brand.constants"
import { BrandDto } from "api/repositories/brand/brand.types"
import { COUNTRY_CD } from "constants/country"
import { DOMAINS, getCurrentDomain, isKyolook } from "constants/domains/domains"

const CURRENCY = {
  KRW: "KRW",
  JPY: "JPY",
}

const BUSINESS_TYPE = {
  NORMAL: "NORMAL",
  WHOLESALE: "WHOLESALE",
}

export const BUSINESS_TYPE_CD = {
  NORMAL: "1",
  WHOLESALE: "2",
}

export const BILLING_TYPE = {
  FREE: "FREE",
  PAID: "PAID",
}

export const BILLING_TYPE_CD = {
  FREE: 1,
  PAID: 2,
}

export const CATEGORY_ID = {
  FASHION: 1,
  BEAUTY: 2,
  FNB: 3,
  HOTEL: 4,
  ETC: 5,
}

export const DEPARTURE_COUNTRY = {
  JP: "81",
  KR: "82",
}

export const DESTINATION_COUNTRY = {
  JP: "81",
  KR: "82",
}

const getLectureOnlyBrandId = () => {
  switch (getCurrentDomain()) {
    case DOMAINS.ONEULOOK:
    case DOMAINS.GLOVV_KR:
      return 1623
    case DOMAINS.KYOLOOK:
    case DOMAINS.GLOVV_JP:
      break
    default:
      return 0
  }
}

const isLectureOnlyBrand = (brandId?: number) => {
  if (!brandId) return false
  
  switch (getCurrentDomain()) {
    case DOMAINS.ONEULOOK:
    case DOMAINS.GLOVV_KR:
      return [1623, 1823, 2307].includes(brandId)
    case DOMAINS.KYOLOOK:
    case DOMAINS.GLOVV_JP:
      return false
    default:
      return false
  }
}

const isJapanBrandInKorea = (brand: Pick<BrandDto, 'currency' | 'destinationCountry'>) => {
  return (
    brand.currency === CURRENCY.KRW && 
    brand.destinationCountry.includes(DESTINATION_COUNTRY.JP)
  )
}

/** 
 * ```md
 * (임시케이스) 일본은 패션 시딩패스 결제를 운영에서 별도 처리해서,
 * campaign_payments DB에 결제내역이 없고, 무료(현금) 브랜드로 변경해서 처리하고 있음
 * 한국에서 결제하는 경우도 마찬가지. 구분을 departureCountryCode로 임시처리
 */
const isKyolookSeedingPassActive = (brand: Pick<BrandDto, 'billingType' | 'departureCountryCode'>) => {
  return (
    brand.billingType === BRAND_DTO_ENUMS.BILLING_TYPE.FREE && (
      isKyolook() || 
      (!isKyolook() && brand.departureCountryCode === COUNTRY_CD.JP)
    )
  )
}

const BRAND = {
  CURRENCY,
  BUSINESS_TYPE,
  BUSINESS_TYPE_CD,
  BILLING_TYPE,
  BILLING_TYPE_CD,
  CATEGORY_ID,
  DEPARTURE_COUNTRY,
  DESTINATION_COUNTRY,
  getLectureOnlyBrandId,
  isLectureOnlyBrand,
  isJapanBrandInKorea,
  isKyolookSeedingPassActive,
}

export default BRAND
